
















































































































































































































































































































































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import _ from 'lodash'

export default {
    name: 'evaluation'

    props:
        uid:
            type: String

    data: ()->
        errors: {}
        min: 0
        max: 10
        cap_max: 1
        active_text: ""
        false: false
        # Added by me
        # Loading page if data is not loaded
        loading: true
        save_dialog_visible: false
        finished_dialog_visible : false
        show_cols: false
        # Reveals only last evaluation
        lastEvaluation_cols: true
        width_button_text: "Afficher plus d'évaluations"
        create_evaluation_text: "Créer une evaluation"
        readonly: false
        clearable: false
        picker_options: {firstDayOfWeek:1, disabledDate:@disabledDate}
        # Pagination for table
        pager_count: 5
        current_page: 1
        page_size: 5
        # Error Trigger for Evaluation Dialog
        error_trigger1: false
        error_trigger2: false

        selected_userjob: ''
        selected_evaluation:''
        userjobs: []
        activities: []
        knowledges: []
        skills: []
        qualities: []
        capacitations: []
        #Added by me 
        managers:[]
        # selected_manager:''
        
        evaluations:[]
        evaluation_form: {
            uid:'',
            user_job:'',
            finished:false,
            evaluator:'',
            date:'',
            name:''
        }
        evalcomment: {
            uid:'',
            text:'',
            eval:''
        }

        props: {
          children: 'tasks'
          label: 'name'
        }
        
    computed:

        has_evaluation_right: ()->
            if @uid == @$store.state.user_datas.app_user.uid
                return false
            return @has_access_right('users_skills_edit')
        has_deletion_right: ()->
            if @uid == @$store.state.user_datas.app_user.uid
                return false
            return @has_access_right('evaluation_self_delete')

        doc_url: ()->
            # console.log "DOCURL ", settings.document_url
            return settings.document_url
        width_icon_class: ()->
            class_str = 'fa fa-expand'
            if @show_cols
                class_str = 'fa fa-compress'
            return class_str
            # Order by method thanks to lodash
        data_filtered: ()->
            return _.orderBy(@evaluations,'date','asc')

        orderedDates: ()->
            # return _.orderBy(@evaluations,'date','asc')
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data
            #Reveals only the last evaluation
        lastEvaluation: ()-> 
            lasteval = _.orderBy(@evaluations,'date','asc')
            lasteval.slice(-1)

        # Reveal only finished unfinished evaluations, no order by
        unfinishedEvaluations: ()->
            return @evaluations.filter (x) -> x.finished == false
        # If there is any evaluations for graph
        finishedEvaluations: ()->
            return @evaluations.filter (x) -> x.finished == true
        
    methods:
        has_access_right: t.has_access_right
        date_formatter: t.date_formatter
        # Pagination :
        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val
        # Disables users from creating dates in the future
        disabledDate: (time)->
            if time > new Date()
                return time.getTime() > Date.now() - 8.64e7;
            else if time < new Date()
                return time.getTime() < Date.now() - 8.64e7;
            else
                return false
            return false
            # return time.getTime() > Date.now()
        # Evaluation percentage calculator for finished and unfinished evaluations.
        evaluation_cell: (data,ev)->
            lvl = 0
            lvl_waited = 0
            percentage = 0
            # If skill has tasks (parent / child)
            if ev.finished == false
                if data.tasks? and data.tasks.length > 0
                    data.tasks.forEach (d)->
                        d.evaluation_set.forEach (e)->
                            if e.eval_uid == ev.uid
                                lvl += e.user_skill_level
                                lvl_waited += d.level_waited
                                percentage = ((lvl/lvl_waited)*100).toFixed(2)
                else
                    data.forEach (a)->
                        a.evaluation_set.forEach (e)->
                            if e.eval_uid == ev.uid
                                if a.skill_type != 'capacitation'
                                    lvl += e.user_skill_level
                                    lvl_waited += a.level_waited
                                    percentage = ((lvl/lvl_waited)*100).toFixed(2)
                                else
                                    if e.user_skill_level == 1
                                        percentage = true
                                    else if e.user_skill_level == 0
                                        percentage = false
            else
                if data.tasks? and data.tasks.length > 0
                    data.tasks.forEach (d)->
                        d.evaluation_set.forEach (e)->
                            if e.eval_uid == ev.uid
                                lvl += e.user_skill_level
                                lvl_waited += e.user_skill_minimal_level_waited
                                percentage = ((lvl/lvl_waited)*100).toFixed(2)
                else
                    data.forEach (a)->
                        a.evaluation_set.forEach (e)->
                            if e.eval_uid == ev.uid
                                if a.skill_type != 'capacitation'
                                    lvl += e.user_skill_level
                                    lvl_waited += e.user_skill_minimal_level_waited
                                    percentage = ((lvl/lvl_waited)*100).toFixed(2)
                                else
                                    if e.user_skill_level == 1
                                        percentage = true
                                    else if e.user_skill_level == 0
                                        percentage = false
            return percentage
        # A note for all skills and tasks
        evaluation_task_text: (data,ev)->
            for e in data.evaluation_set                
                if e.eval_uid == ev.uid
                    return e.user_skill_level+" / "+e.user_skill_minimal_level_waited
            return "-"

        skill_table_colors:(item)->
            return "font-weight:bold;"
        
                        
        define_marks: (item)->
            obj = {}
            obj[item.level_waited] = item.level_waited.toString()
            return obj

            
        toggle_width: () ->
            self = @
            if self.show_cols
                self.show_cols = false
                self.lastEvaluation_cols = true
                self.width_button_text = "Afficher plus d'évaluations"
            else
                self.show_cols = true
                self.lastEvaluation_cols = false
                self.width_button_text = "Masquer les évaluations"

        slide_change: (skill,item)->
            self = @
                # Verification if the uid == uid
            console.log("slide_change")
            skill.evaluation_set.forEach (e)->
                if e.eval_uid == item.eval_uid
                    skill.app_user_user_skill['uid'] = e.user_skill_uid
                    skill.app_user_user_skill['user_uid'] = self.uid
                    skill.app_user_user_skill['skill_uid'] = skill.uid
                    skill.app_user_user_skill['level'] = item.user_skill_level
                    console.log("item.user_skill_level", item.user_skill_level)
                    m.run('save_user_skill', [skill.app_user_user_skill])
                    .then (resp)->
                        if resp.body.data.user_skill_form_mutation.form_ret == 'failed'
                            return n.access_denied()
                        if resp.body.data.user_skill_form_mutation.errors.length > 0
                            n.form_error()
                        else
                            # n.success()
                    .catch (resp)->
                        n.catch_error(resp, "evaluation: slide_change()")
                    return
            
        # Indication for levels + with phrases 1
        # Added extra if statements :
        #                      < 3 = RED , >= 3 and <=6 ORANGE, > level waited = Green 
        define_color: (skill,ev)->
            for e in skill.evaluation_set
                if e.eval_uid == ev.uid
                    if e.user_skill_minimal_level_waited <= e.user_skill_level
                        return "text-success bold"
                    if e.user_skill_level >=3
                        return "text-warning bold"
                    else if e.user_skill_level < 3
                        return "text-danger bold"

        # Indication for levels + with phrases 2
        result_level_text: (skill,ev)->
            for e in skill.evaluation_set
                if e.eval_uid == ev.uid
                    if e.user_skill_minimal_level_waited <= e.user_skill_level
                        return "Compétences en adéquation"
                    if e.user_skill_level >=3
                        return "Elever le niveau de compétence"
                    else if e.user_skill_level < 3
                        return "Formation requise"
        
        set_selected_userjob: ()->
            self = @
            if self.selected_userjob != ''
                self.get_app_user_job_skills()
                self.get_evaluations()
                self.get_managers()
            # console.log "USERJOB SELECTED", @selected_userjob

        set_default_app_user_user_skill: (skill)->
            if skill.app_user_user_skill is null
                # console.log "SET DEFAULT ", skill
                skill.app_user_user_skill = {uid:'', level:0}
            if skill.tasks? and skill.tasks.length > 0
                for task in skill.tasks
                    @set_default_app_user_user_skill(task)
            return

        get_app_user_job_skills: ()->
            self = @
            self.loading = true
            job_uid = null
            for uj in @userjobs
                if uj.uid == @selected_userjob
                    job_uid = uj.job.uid
                    break
            q.run('get_app_user_job_skill_set', [@uid, job_uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("evaluation: get_app_user_job_skills: then", e.message)
                else
                    #  console.log "GET APP USER JOB SKILLS : ", resp.body.data.app_user_job_skill_set
                    for skill in resp.body.data.app_user_job_skill_set
                        self.set_default_app_user_user_skill(skill)
                    self.activities = resp.body.data.app_user_job_skill_set.filter (x)-> x.skill_type == 'activity'
                    self.knowledges = resp.body.data.app_user_job_skill_set.filter (x)-> x.skill_type == 'knowledge'
                    self.qualities = resp.body.data.app_user_job_skill_set.filter (x)-> x.skill_type == 'quality'
                    self.skills = resp.body.data.app_user_job_skill_set.filter (x)-> x.skill_type == 'skill'
                    self.capacitations = resp.body.data.app_user_job_skill_set.filter (x)-> x.skill_type == 'capacitation'
                    self.loading = false
            .catch (resp)->
                n.catch_error(resp, "evaluation: get_app_user_job_skills()")

        get_app_user_userjobs: ()->
            self = @
            # q.run('get_app_user_job_set', [@uid])
            q.run('get_skill_user_job_set', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("evaluation: get_app_user_userjobs: then", e.message)
                else
                    # console.log "GET APP USER JOBS : ", resp.body.data.skill_user_job_set
                    self.userjobs = resp.body.data.skill_user_job_set
                    if self.userjobs.length == 0
                        self.selected_userjob = ''
                        self.loading = false
                        self.alert = true
                    else
                        self.selected_userjob = self.userjobs[0].uid
                        self.get_app_user_job_skills()
                        self.get_evaluations()
                        self.get_managers()
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "evaluation: get_app_user_userjobs()")

        get_evaluations: ()->
            self = @
            q.run('get_evaluation_set', [@selected_userjob])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("evaluation: get_evaluations: then", e.message)
                else
                    # console.log "GET Evaluations : ", resp.body.data.evaluation_set
                    self.evaluations = resp.body.data.evaluation_set
            .catch (resp)->
                n.catch_error(resp, "evaluation: get_evaluations()") 

        get_managers: ()->
            self = @
            # console.log "GET MANAGERS ", @$store.getters.current_company.uid
            q.run('get_manager_set', [@$store.getters.current_company.uid, @uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("managers: get_managers: then", e.message)
                else
                    # console.log "GET MANAGERS : ", resp.body.data.manager_set
                    if resp.body.data.manager_set.length > 0
                        self.managers = resp.body.data.manager_set
                        # self.selected_user = resp.body.data.manager_set[0]['uid']
            .catch (resp)->
                n.catch_error(resp, "managers: get_managers()")

        # Delete evaluation
        delete_evaluation: (evaluation_uid)->
            # console.log  "DELETE EVALUATION", evaluation_uid
            self = @
            self.$confirm("Êtes-vous sûr·e de vouloir supprimer cette évaluation ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "EVALUATION DELETE", evaluation_uid
                    m.run('delete_object',['evaluation',evaluation_uid])
                    .then (resp)->
                        # console.log "DELETE EVALUATION", resp.body.data.evaluation_deletion
                        if resp.body.data.evaluation_deletion.ok
                            n.success()
                            self.get_app_user_job_skills()
                            self.get_evaluations()
                            self.get_managers()
                            self.evaluation_form = {
                                uid: '',
                                finished:false
                                evaluator: '',
                                user_job:'',
                                date:'',
                                name:''
                            }
                        else
                            n.gql_error("evaluation: delete_evaluation: then", resp.body.data.evaluation_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "evaluation: delete_evaluation()")
                .catch (cancel)->
                    return
        save_comment: ()->
            self = @
            m.run('save_evalcomment',[self.evalcomment])
            .then (resp)->
                if resp.body.data.evalcomment_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.evalcomment_form_mutation.errors.length > 0
                    self.errors = resp.body.data.evalcomment_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                else
                    self.errors={}
                    self.evalcomment = {
                        uid:'',
                        text:'',
                        eval:''
                    }
            .catch (resp)->
                n.catch_error(resp,"evalcomment: save()")

        deep_copy_evaluation: (item)->
            self = @
            self.evaluation_form = t.deep_copy(item)
            self.selected_evaluation = item.uid
            self.evaluation_form.uid = item.uid
            self.evalcomment.eval = item.uid
            self.evaluation_form.user_job = self.selected_userjob
            self.evaluation_form.evaluator = item.evaluator.uid
            self.finished_dialog_visible = true

        finished_save: (evaluation_form,evalcomment)->
            self = @
            date = new Date()
            self.evaluation_form.finished = true
            if self.evaluation_form.date != date.getDate() + '-' + (date.getMonth()+1) + '-' + date.getFullYear()
                self.evaluation_form.date = date.getFullYear() + '-' + ('0'+(date.getMonth()+1)) + '-' + date.getDate()
            self.save_comment(evalcomment)
            self.save(evaluation_form)
              
            
        accept_cancel: ()->
            self = @
            self.save_dialog_visible = false
            self.error_trigger1 = false
            self.error_trigger2 = false
            self.errors = {}
            self.evaluation_form = {
                uid: '',
                finished:false
                evaluator: '',
                user_job:'',
                date:'',
                name:''
            }
        finished_cancel:()->
            @finished_dialog_visible = false

        save_form: () ->
            self = @
            self.evaluation_form = {
                uid: '',
                finished:false
                evaluator: '',
                user_job:'',
                date:'',
                name:''
            }

        pre_save: ()->
            if @evaluation_form.date !="" && @evaluation_form.evaluator !=""
                @error_trigger1 = false
                @error_trigger2 = false
                @save(@evaluation_form)
            else
                if @evaluation_form.evaluator == ""
                    @error_trigger1 = true
                else
                    @error_trigger1 = false
                if @evaluation_form.date == ""
                    @error_trigger2 = true
                else
                    @error_trigger2 = false
                n.form_error()
            

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        save: ()->
            self = @
            self.evaluation_form.user_job = self.selected_userjob
            m.run('save_evaluation',[self.evaluation_form])
            .then (resp)->
                if resp.body.data.evaluation_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.evaluation_form_mutation.errors.length > 0
                    self.errors = resp.body.data.evaluation_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                else
                    self.errors={}
                    n.success()
                    self.save_dialog_visible = false
                    self.finished_dialog_visible = false
                    self.evaluation_form = {
                        uid: '',
                        finished:false
                        evaluator: '',
                        user_job:self.selected_userjob,
                        date:'',
                        name:''
                    }
                    self.selected_userjob = self.evaluation_form.user_job
                    self.get_app_user_job_skills()
                    self.get_evaluations()
                    self.get_managers()
            .catch (resp)->
                n.catch_error(resp,"evaluation: save()")
  
    beforeMount: ()->
        # console.log "EVALUATION"
        @get_app_user_userjobs()
        
}

